import { Component, OnInit, OnDestroy, ChangeDetectorRef, NgZone } from '@angular/core';
import { LanguageService } from 'src/appv2/services/language.service';
import { environment } from 'src/environments/environment';
import { SharedService } from '../shared/shared.service';
import { State } from 'src/appv2/ngrx/reducers';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { loadNewTab } from 'src/appv2/ngrx/actions/newTabOpen.actions';

declare let $: any;

@Component({
  selector: 'app-single-session',
  templateUrl: './single-session.component.html',
  styleUrls: ['./single-session.component.scss']
})
export class SingleSessionComponent implements OnInit, OnDestroy {
  staticText: any;
  brandName: string;
  isWhitelabel: boolean;
  storeSubscription$: Subscription;
  agencyMeta: any;
  constructor(
    private languageService: LanguageService,
    private store: Store<State>,
    private sharedService: SharedService,
    private cdr: ChangeDetectorRef) {
    /**
     * Date: 21/Nov/2023
     * Author: Amit Kumar
     * Summary: Html take time to detect Changes
     * Description: Html take time to detect Changes
     * sometime Html not detect changes so
     * i added setTimeout and angular detectChanges function to update text on html file
     */
    this.isWhitelabel = !environment.rootAgencyDomain.includes(window.location.host);
    setTimeout(() => {
      this.staticText = languageService.getStaticText().shared.singleSession;
      this.brandName = sessionStorage.getItem('brand');
      this.staticText.openInAnotherWindow = this.staticText.openInAnotherWindow
        .replace(/null/g, this.brandName);
      this.cdr.detectChanges();
    }, 100);
    this.storeSubscription$ = this.store.select((state) => state)
      .subscribe(({ agencyDetails }) => {
        this.agencyMeta = agencyDetails?.meta || JSON.parse(localStorage.getItem('bp_parent_meta') || '')?.meta;
      });
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.storeSubscription$?.unsubscribe();
  }

  actionHandler(type: 'close' | 'useHere'): void {
    if (type === 'useHere') {
      sessionStorage.removeItem('isNewTabOpen');
      this.store.dispatch(loadNewTab({ isNewTabOpen: false }));
      window.location.href = this.isWhitelabel
        ? this.sharedService.validateUrl(this.agencyMeta?.domain?.dashboard || this.agencyMeta?.domains[0])
        : environment.domain;
    } else {
      window.location.href = this.isWhitelabel
        ? this.sharedService.validateUrl(this.agencyMeta?.websiteUrl || '')
        : environment.websiteUrl;
    }
  }

  /**
   * Date: 21/Nov/2023
   * Author: Amit Kumar
   * Summary: isWebsiteUrl use to show close btn
   * Description:
   * If iswhiltelabel and website URL not in agencyMeta
   * then hide close btn
   * else show close btn
   */
  get isWebsiteUrl() {
    return (this.isWhitelabel && this.agencyMeta?.websiteUrl) || !this.isWhitelabel;
  }

}
